export default __webpack_public_path__ + "static/media/ic_european_union.219f3c11.svg";